import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Loader from '../../common/loader';
import ModalComponent from '../../components/ModalComponent/ModalComponent';
import notFoundImage from '../../assets/img/notFound3.jpg';
import TabActionButton from './TabActionButton';
import EditReportModalBody from './EditReportModalBody';
import { messages } from '../../common/messages';
import config from '../../views/config/App_data';
import { lengthCheck, tabActionButtonStyles } from '../../common/constant';
import { nextAwareRoute } from '../../common/cfa1NextRoutes';
import { renderSanitizedHTML } from '../../common/function';

/* eslint-disable*/

export default class TabList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TabHeader: '',
      currentIndex: 0,
      tabsData: [],
      isLoading: false,
      apiService: '',
      reportedItem: '',
      reportComment: '',
      isSubjectError: false,
      isCommentError: false,
      reportEditHeader: '',
      contactSubject: '',
      contactComment: '',
      reportEditItem: {},
      isReportModelOpen: false,
      isReportEditModalOpen: false,
      isViewFeedbackModalOpen: false,
      selectedFeedbackItemId: null,
      isSendFurtherLoading: false,
      isFurtherHelpFormOpen: false,
      isFurtherHelpSubmitForm: false,
      isReportError: false,
    };
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount = async () => {
    const { currentIndex } = this.state;
    const { tabList } = this.props;
    tabList.length && this.getData(currentIndex);
  };

  getData = async (index) => {
    this.setState({ isLoading: true });

    this.setState(
      {
        currentIndex: index,
        tabsData: [],
      },
      async () => {
        const {
          state: { currentIndex },
          props: { section, level = '' },
        } = this;
        const { tabList, apiServiceProvider } = this.props;
        const tabsData = await apiServiceProvider[tabList[currentIndex][section]]({ level });
        this.setState({
          tabsData: tabsData.success ? tabsData.data : [],
          isLoading: false,
        });
      },
    );
  };

  onView = async (apiService, items) => {
    const { currentIndex } = this.state;
    const { tabList, apiServiceProvider, level } = this.props;
    const selectedTabWiseServices = tabList[currentIndex];

    const { saveItemTableName } = selectedTabWiseServices;
    if (apiService) {
      const getParameterList = await apiServiceProvider[apiService]({
        ...items,
      });

      this.context.router.push({
        pathname: await this.onNavigateTo(
          nextAwareRoute(selectedTabWiseServices.redirectionPath),
          getParameterList.data,
        ),
        query: {
          ...(items[`${saveItemTableName}.mock_id`] && {
            mockId: items[`${saveItemTableName}.mock_id`],
          }),
          ...(getParameterList.data &&
            getParameterList.data.media_type === 'webinar' && {
              mediaType: 'webinar',
            }),
        },
      });
    } else {
      const mapping = {
        readingId: `${saveItemTableName}.readingId`,
        chapterId: `${saveItemTableName}.chapterId`,
        id: `video_id`,
      };
      this.context.router.push({
        pathname: await this.replaceValues(
          nextAwareRoute(selectedTabWiseServices.redirectionPath),
          items,
          mapping,
        ).replace(':level', level),
      });
    }
  };
  replaceValues = (template, data, mapping) => {
    // eslint-disable-next-line id-length
    return template.replace(/:(\w+)/g, (_, key) => {
      const actualKey = mapping[key] || key;
      const value = actualKey
        .split('.')
        .reduce((obj, prop) => (obj && obj[prop] ? obj[prop] : data[actualKey]), data);
      return value !== undefined ? value : `:${key}`;
    });
  };
  onNavigateTo = (path, parameterList) => {
    let navigateURL = path;
    for (const key in parameterList) {
      navigateURL = navigateURL.replace(`:${key}`, parameterList[key]);
    }
    return navigateURL;
  };

  onDelete = async (apiService, items) => {
    const { currentIndex } = this.state;
    const { id, item_id, flash_card } = items;
    const { exam = `esg` } = this.props;

    const { apiServiceProvider } = this.props;
    if (flash_card) {
      const payload = {
        type:
          apiService === 'deleteSavedQuestion'
            ? 'question'
            : apiService === 'deleteSavedNotes'
              ? 'notes'
              : 'video',
        question_type: '',
        exam,
        level: '',
        item_id,
      };
      await apiServiceProvider['deleteFlashCard'](payload);
    }
    const payLoad = exam !== 'frm' ? { id } : items;
    const tabsData = await apiServiceProvider[apiService](payLoad);
    if (tabsData.success) {
      this.getData(currentIndex);
      this.setState({
        apiService: '',
        reportedItem: '',
        isReportModelOpen: false,
      });
    } else {
      this.setState({
        apiService: '',
        reportedItem: '',
        isReportModelOpen: false,
      });
    }
  };
  toggleAlertReport = async (apiService, items) => {
    this.setState({
      isReportModelOpen: !this.state.isReportModelOpen,
      apiService,
      reportedItem: items,
    });
  };
  checkEmptyField = (fieldValue, fieldText) => {
    if (fieldValue === '') {
      this.setState({
        [fieldText]: true,
      });
      return true;
    }
    return false;
  };
  onViewFeedbackModalToggle = (apiService, items) => {
    const willOpen = !this.state.isViewFeedbackModalOpen;
    this.setState(
      {
        isViewFeedbackModalOpen: willOpen,
        selectedFeedbackItemId: willOpen && items ? items.id : null,
        isFurtherHelpFormOpen: false,
      },
      () => {
        !this.state.isViewFeedbackModalOpen &&
          this.setState({
            contactSubject: '',
            contactComment: '',
            isFurtherHelpSubmitForm: false,
          });
      },
    );
  };

  onToggleFurtherHelpButton = () => {
    this.setState({
      isFurtherHelpFormOpen: !this.state.isFurtherHelpFormOpen,
      isFurtherHelpSubmitForm: false,
      contactSubject: '',
      contactComment: '',
      isSubjectError: false,
      isCommentError: false,
    });
  };
  onHandleFurtherHelpChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      isSubjectError: false,
      isCommentError: false,
    });
  };
  onHandleFurtherHelpSubmit = async () => {
    const { apiServiceProvider } = this.props;
    const { contactSubject, contactComment } = this.state;
    if (this.checkEmptyField(contactSubject, 'isSubjectError')) return;
    if (this.checkEmptyField(contactComment, 'isCommentError')) return;
    this.setState({ isFurtherHelpFormOpen: true, isSendFurtherLoading: true });
    await apiServiceProvider['sendFurtherHelpRequest']({
      contactSubject,
      contactComment,
    });
    this.setState({
      isFurtherHelpSubmitForm: true,
      isSendFurtherLoading: false,
    });
  };
  onReportCommentChange = (event) => {
    this.setState({
      reportComment: event.target.value,
      isReportError: false,
    });
  };
  onReportEditModalToggle = async (apiService, items) => {
    const { isReportEditModalOpen, currentIndex } = this.state;
    if (!isReportEditModalOpen) {
      const { comment = '', tableKey = '', tableName = '' } = items;
      const { tabList } = this.props;
      const { saveItemTableName, savedItemTableKey } = tabList[currentIndex];
      // Report rows key the included question by the edition-specific association alias
      // (e.g. 2027 -> cfa1_2027_question / cfa1_2027_cbt_question). Resolve defensively: a missing
      // or differently-aliased nested object must never crash the edit click.
      const dottedTitle = items[`${saveItemTableName}.${savedItemTableKey}`];
      const nestedTitle =
        tableName && items[tableName] ? items[tableName][tableKey] : '';
      const reportTitle = dottedTitle || nestedTitle || '';

      const reportModalHeader =
        reportTitle.length > 150 ? ` ${reportTitle.substr(0, 100)}...` : ` ${reportTitle}`;

      this.setState(
        {
          reportComment: comment,
          reportEditItem: { ...items, apiService },
          reportEditHeader: reportModalHeader,
          isReportError: false,
        },
        () => {
          this.setState({
            isReportEditModalOpen: !this.state.isReportEditModalOpen,
            isReportError: false,
          });
        },
      );
    } else {
      this.setState({
        isReportEditModalOpen: !this.state.isReportEditModalOpen,
        reportEditItem: {},
        reportComment: '',
        reportEditHeader: '',
        isReportError: true,
      });
    }
  };
  onReportEditSubmit = async (event) => {
    event.preventDefault();
    const { reportComment, reportEditItem, currentIndex } = this.state;
    const { apiService, id } = reportEditItem;
    if (reportComment.trim().length) {
      const { apiServiceProvider, level = '' } = this.props;
      const editReport = await apiServiceProvider[apiService]({
        id,
        comment: reportComment,
        level,
      });
      if (editReport.success) {
        this.setState(
          {
            isReportEditModalOpen: !this.state.isReportEditModalOpen,
            isReportError: false,
            reportEditItem: {},
            reportComment: '',
            reportEditHeader: '',
          },
          () => {
            this.getData(currentIndex);
          },
        );
      }
    } else {
      this.setState({
        isReportError: true,
        reportEditItem: {},
      });
    }
  };
  render() {
    const { TabHeader, section, tabList } = this.props;

    const {
      currentIndex,
      tabsData,
      isLoading,
      isReportModelOpen,
      reportedItem,
      apiService,
      contactSubject,
      contactComment,
      isReportEditModalOpen,
      isReportError,
      isFurtherHelpSubmitForm,
      isViewFeedbackModalOpen,
      selectedFeedbackItemId,
      isFurtherHelpFormOpen,
      isSendFurtherLoading,
      reportComment,
      isSubjectError,
      isCommentError,
      reportEditHeader,
    } = this.state;
    const showTabsData = tabList[currentIndex];
    const {
      savedItemTitle,
      saveItemTableName,
      savedItemTableKey,
      reportedItemTableKey,
      idFieldName,
    } = showTabsData;
    const { ZERO, HUNDRED, ONE_HUNDRED_FIFTY } = lengthCheck;
    return (
      <div>
        <div className='padding_bottom_30'>
          <h1 className='section_head padding_bottom_30'>{TabHeader}</h1>
          <div className='d-flex header-card-dashboard tab-header-wrap'>
            <ul className='dashboard-card-header-tab'>
              {/* ===========> {{ REPORTED AND SAVED ITEM TAB STARTED HERE }} <============ */}
              {tabList.map((tab, index) => {
                if (!tabList[index][section]) {
                  return null;
                }
                return (
                  <li
                    key={tab.label}
                    onClick={() => {
                      this.getData(index);
                    }}
                    className={currentIndex === index && messages.ACTIVE}
                  >
                    <span> {tab.label}</span>
                  </li>
                );
              })}
              {/* ===========> {{ REPORTED AND SAVED ITEM TAB  ENDED  HERE }} <============ */}
            </ul>
          </div>
          {/* ===========> {{ REPORTED AND SAVED ITEM TAB CARD BODY STARTED HERE }} <=========== */}
          <div className='card tab-body-wrap'>
            <div className='card-block dashboard-cards-scroll my-1'>
              <div className='chart-wrapper'>
                {isLoading ? (
                  <div className='card-block-loader'>
                    <Loader />
                  </div>
                ) : tabsData && tabsData.length ? (
                  tabsData.map((items, index) => {
                    const topic = items[`${saveItemTableName}.${savedItemTableKey}`]
                      ? items[`${saveItemTableName}.${savedItemTableKey}`]
                      : items[`${savedItemTableKey}`]
                        ? items[`${savedItemTableKey}`]
                        : '';

                    return (
                      <div id={`savedque_${items.id}`} key={index} className='flash_card_box'>
                        {/* --------->  CONDITION FOR ONLY RESOLVED AND PENDING TAG <--------- */}
                        {section === 'reportAPIService' && (
                          <div className='mb-1'>
                            <span>
                              <strong> {messages.TICKET_ID}: </strong> {items.id}
                            </span>

                            <span className={`float-right status-${items.status}`}>
                              <strong className='text-capitalize'>{items.status}</strong>
                            </span>
                          </div>
                        )}
                        <div>
                          <span>
                            <strong> {savedItemTitle}: </strong>
                            {items[idFieldName || 'id']}
                          </span>
                          <TabActionButton
                            tooltipText={messages.DELETE}
                            buttonCss={tabActionButtonStyles.delete}
                            buttonColor={tabActionButtonStyles.deleteColor}
                            apiService={
                              section === 'reportAPIService'
                                ? showTabsData['reportDeleteAPIService']
                                : showTabsData['saveItemDeleteAPIService']
                            }
                            onActionButtonClick={this.toggleAlertReport}
                            items={items}
                          />
                          {items.isSend && (items.answer || items.reply) && (
                            <TabActionButton
                              tooltipText={messages.VIEW_FEEDBACK}
                              buttonCss={tabActionButtonStyles.viewFeedback}
                              buttonColor={tabActionButtonStyles.primaryColor}
                              apiService={showTabsData['editAPIService']}
                              onActionButtonClick={this.onViewFeedbackModalToggle}
                              items={{
                                ...items,
                                tableName: saveItemTableName,
                                tableKey: savedItemTableKey,
                              }}
                            />
                          )}
                          <TabActionButton
                            tooltipText={messages.VIEW}
                            buttonCss={tabActionButtonStyles.view}
                            buttonColor={tabActionButtonStyles.primaryColor}
                            apiService={showTabsData['viewItemAPIService']}
                            onActionButtonClick={
                              !(
                                savedItemTitle === 'Video ID' ||
                                savedItemTitle === 'CBT Question Id'
                              ) && this.onView
                            }
                            items={items}
                          />
                          {/* --------->  CONDITION FOR ONLY EDIT REPORT BUTTON <--------- */}

                          {!items.isSend &&
                            !items.answer &&
                            items.status !== messages.RESOLVED &&
                            section === 'reportAPIService' ? (
                            <TabActionButton
                              tooltipText={messages.EDIT_REPORT}
                              buttonCss={tabActionButtonStyles.edit}
                              buttonColor={tabActionButtonStyles.primaryColor}
                              apiService={showTabsData['editAPIService']}
                              onActionButtonClick={this.onReportEditModalToggle}
                              items={{
                                ...items,
                                tableName: saveItemTableName,
                                tableKey: savedItemTableKey,
                              }}
                            />
                          ) : null}
                        </div>
                        {topic && (
                          <p className='mt-1'>
                            <strong>{messages.TOPIC}: </strong>
                            <span>
                              {topic && topic.length > 150
                                ? ` ${topic.substr(0, 100)}...`
                                : ` ${topic}`}
                            </span>
                          </p>
                        )}
                        {items.flash_card && (
                          <p className='mt-1'>
                            <strong>{messages.NOTE}: </strong>
                            <span>
                              {renderSanitizedHTML(
                                items.flash_card && items.flash_card.length > ONE_HUNDRED_FIFTY
                                  ? ` ${items.flash_card.substr(ZERO, HUNDRED)}...`
                                  : ` ${items.flash_card}`,
                              )}
                            </span>
                          </p>
                        )}
                        {section === 'reportAPIService' && (
                          <p className='mt-1'>
                            <strong>{messages.REPORT}: </strong>
                            <span>
                              {renderSanitizedHTML(
                                items[reportedItemTableKey].length > ONE_HUNDRED_FIFTY
                                  ? ` ${items[reportedItemTableKey].substr(ZERO, HUNDRED)}...`
                                  : ` ${items[reportedItemTableKey]}`,
                              )}
                            </span>
                          </p>
                        )}
                        {/*------------> START MODAL FOR REPORTED ITEM EDIT START HERE <------------ */}
                        <ModalComponent
                          isModalOpen={isReportEditModalOpen}
                          modalHeaderText={reportEditHeader}
                          onModalToggle={this.onReportEditModalToggle}
                        >
                          <EditReportModalBody
                            onReportEditSubmit={this.onReportEditSubmit}
                            onReportEditModalToggle={this.onReportEditModalToggle}
                            reportComment={reportComment}
                            onReportCommentChange={this.onReportCommentChange}
                            isReportErrorMessageDisplay={isReportError}
                            reportErrorMessage={messages.REPORT_CANT_BE_EMPTY}
                          />
                        </ModalComponent>
                        {/*------------> START MODAL FOR REPORTED ITEM EDIT ENDED HERE <------------ */}
                        {/*------------> START MODAL FOR VIEW FEEDBACK EDIT START HERE <------------ */}
                        <Modal
                          isOpen={isViewFeedbackModalOpen && selectedFeedbackItemId === items.id}
                          toggle={this.onViewFeedbackModalToggle}
                          className={'modal-primary '}
                        >
                          <ModalHeader>
                            {`Q. ${items.id}`}
                            <span className='pl-1'>{topic}</span>
                            <div className='contact-us-btn float-right'>
                              {!isFurtherHelpFormOpen ? (
                                <Button
                                  className='btn btn-primary'
                                  onClick={this.onToggleFurtherHelpButton}
                                >
                                  <i className='fa fa-question-circle pr-1' aria-hidden='true' />
                                  {messages.FURTHER_HELP}
                                </Button>
                              ) : (
                                <Button
                                  className='btn btn-primary'
                                  onClick={this.onToggleFurtherHelpButton}
                                >
                                  {messages.BACK}
                                </Button>
                              )}
                              <button
                                type='button'
                                className='close'
                                aria-label='Close'
                                onClick={this.onViewFeedbackModalToggle}
                              >
                                <span aria-hidden='true'>×</span>
                              </button>
                            </div>
                          </ModalHeader>
                          <ModalBody>
                            {isFurtherHelpFormOpen && !isFurtherHelpSubmitForm ? (
                              <div className='row'>
                                <div className='col-sm-12 margin_bottom_10'>
                                  <h6 className='mb-1 d-flex'>
                                    {messages.SUBJECT}
                                    <span className={'text-danger'}>*</span>
                                  </h6>
                                  <textarea
                                    id='contactSubject'
                                    name='contactSubject'
                                    rows='2'
                                    className='form-control'
                                    placeholder='Subject..'
                                    onChange={(event) => this.onHandleFurtherHelpChange(event)}
                                    value={contactSubject}
                                  />
                                  <span className={`text-danger`}>
                                    {isSubjectError && messages.SUBJECT_CANT_BE_EMPTY}
                                  </span>
                                </div>
                                <div className='col-sm-12 margin_bottom_10'>
                                  <h6 className='mb-1 d-flex'>
                                    {messages.COMMENT}
                                    <span className={'text-danger'}>*</span>
                                  </h6>
                                  <textarea
                                    id='contactComment'
                                    name='contactComment'
                                    rows='6'
                                    className='form-control'
                                    placeholder='Comment..'
                                    onChange={(event) => this.onHandleFurtherHelpChange(event)}
                                    value={contactComment}
                                  />
                                  <span className={`text-danger`}>
                                    {isCommentError && messages.COMMENT_CANT_BE_EMPTY}
                                  </span>
                                </div>
                                <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                                  <button
                                    type='submit'
                                    className='btn btn-primary active pointer_class'
                                    onClick={this.onHandleFurtherHelpSubmit}
                                  >
                                    {isSendFurtherLoading
                                      ? messages.PLEASE_WAIT
                                      : messages.SEND_REQUEST}
                                  </button>
                                </div>
                              </div>
                            ) : isFurtherHelpSubmitForm ? (
                              <div className='card-block'>
                                <div className='row'>
                                  <div className='col-sm-12 report-Success-card'>
                                    <img
                                      src={`${config.frontend_url}/img/success-ic.svg`}
                                      alt='Success Icon'
                                    />
                                    <label className='form-control-label' htmlFor='textarea-input'>
                                      <strong>{messages.REQUEST_SENT_SUCCESSFULLY}</strong>
                                    </label>
                                    <button
                                      type='button'
                                      className='btn btn-primary active pointer_class  min-vw-120'
                                      onClick={this.onViewFeedbackModalToggle}
                                    >
                                      {messages.CLOSE}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className='text-center'>
                                <p className='margin_bottom_20'>
                                  <span>{renderSanitizedHTML(items.reply || items.answer)}</span>
                                </p>
                              </div>
                            )}
                          </ModalBody>
                        </Modal>
                        {/*------------> START MODAL FOR VIEW FEEDBACK EDIT ENDED HERE <------------ */}
                      </div>
                    );
                  })
                ) : (
                  <div
                    className='text-center'
                    style={{
                      fontSize: '14px',
                      color: 'grey',
                      fontWeight: '500',
                    }}
                  >
                    <img
                      src={notFoundImage}
                      alt='notFoundImage'
                      style={{
                        width: '130px',
                        height: '130px',
                      }}
                    />
                    <p className='mb-0'>{messages.DATA_NOT_FOUND}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* ===========> {{ REPORTED AND SAVED ITEM TAB CARD BODY  ENDED  HERE }} <============== */}
        </div>

        <Modal
          isOpen={isReportModelOpen}
          toggle={this.toggleAlertReport}
          className={'modal-primary '}
        >
          <ModalHeader>
            {messages.Alert}
            <button
              type='button'
              className='close'
              aria-label='Close'
              onClick={this.toggleAlertReport}
            >
              <span aria-hidden='true'>×</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p className='margin_bottom_20'>
                <strong>{messages.DELETE_ALERT_MESSAGE}</strong>
              </p>
              <Button
                className='btn btn-sm btn-primary'
                color='primary'
                onClick={() => this.onDelete(apiService, reportedItem)}
              >
                {messages.OK}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/TabList.jsx